import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/common/Navbar";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import "./index.css"; 

import EmployeeList from "./components/employee/EmployeeList";
import AddEmployeePage from "./components/employee/AddEmployeePage";
import ProtectedRoute from "./layout/ProtectedRoute";
import PeoplePage from "./pages/PeoplePage";
import EmployeeProfile from "./components/employee/EmployeeProfile";
import SalaryData from "./components/employee/SalaryData";
import SelfService from "./pages/SelfService";
import PersonalInfo from "./pages/PersonalInfo";
import AcademicData from "./components/employee/AcademicData";
import WorkExperience from "./components/employee/WorkExperience";
import EmergencyContacts from "./components/employee/EmergencyContacts";
import HealthCondition from "./components/employee/HealthCondition";
import Dashboard from "./pages/Dashboard";
import MainLayout from "./layout/MainLayout";
import AttachmentUpload from "./components/library/AttachmentUpload";
import RequestTimeOff from "./components/leave/RequestTimeOff";
import MyLeaveRequests from "./components/leave/MyLeaveRequests";
import LeaveRequests from "./components/leave/LeaveRequests";
import LeaveDashboard from "./pages/LeaveDashboard";
import Payroll from "./pages/Payroll";
import Calendar from "./pages/CalendarPage";
import CompanyDetails from "./pages/CompanyDetails";
import CompanyEventsNews from "./pages/CompanyEventsNewsPage";
import EmployeePayroll from "./pages/EmployeePayroll";
import MasterScreen from "./pages/MasterScreen";
import ResetPassword from "./pages/ResetPassword";
import AdvancePaymentRequest from "./pages/AdvancePaymentRequest";
import AdvancePaymentRequestList from "./pages/AdvancePaymentRequestList";
import ClientsPage from "./pages/ClientPage";
import ClientDetails from "./components/client/ClientDetails";
import AddNewClient from "./components/client/AddNewClient";
import ClientAttachmentUpload from "./components/client/AddNewClient";

function App() {
  const fullname = sessionStorage.getItem("fullname");
  useEffect(() => {
    document.title = 'ByVal Technologies';
  }, [fullname]);

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Login */}
          <Route path="/" element={<Login />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Protected Routes */}
          <Route
            path="/app/*"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="employees" element={<PeoplePage />} />
            <Route path="addemployees" element={<AddEmployeePage />} />
            <Route path="addemployees/:id" element={<AddEmployeePage />} />
            <Route path="profile" element={<EmployeeProfile />} />
            <Route path="profile/:id" element={<EmployeeProfile />} />
            <Route path="selfservice" element={<SelfService />} />
            <Route path="requesttimeoff" element={<RequestTimeOff />} />
            <Route path="myleaverequests" element={<MyLeaveRequests />} />
            <Route path="leaverequests" element={<LeaveRequests />} />
            <Route path="leavedashboard" element={<LeaveDashboard />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="companydetails" element={<CompanyDetails />} />
            <Route path="companyeventsnews" element={<CompanyEventsNews />} />
            <Route path="employeepayroll" element={<EmployeePayroll />} />
            <Route path="masterscreen" element={<MasterScreen />} />
            <Route path="advancepaymentrequest" element={<AdvancePaymentRequest />} />
            <Route path="advancepaymentrequestlist" element={<AdvancePaymentRequestList />} />
            <Route path="clientslist" element={<ClientsPage />} />
            <Route path="clientdetails/:id" element={<ClientDetails />} />
            <Route path="addnewclient" element={<AddNewClient />} />
            <Route path="addnewclient/:id" element={<AddNewClient />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
